import React, {useEffect, useState} from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {
    getActualSchoolYearRequest,
    getClassificationTypesRequest,
    getUsageTypesRequest
} from "../redux/actions/jointPowersActions";
import {updateContractRequest} from "../redux/actions/contractActions";
import "./ContractForm.css";
import '../error.css'

const ContractForm = ({ contract, setCurrentStep, previousStep, submitButtonText }) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
        defaultValues: contract // Setzt die Standardwerte des Formulars auf die aktuellen Mitarbeiterdaten
    });
    const classificationTypes = useSelector(state => state.jointPower.classificationTypes);
    const isLoadingClassificationTypes = useSelector(state => state.jointPower.loading.getClassificationTypes);
    const usageTypes = useSelector(state => state.jointPower.usageTypes);
    const isLoadingUsageTypes = useSelector(state => state.jointPower.loading.getUsageTypes);
    const isUpdatingContract = useSelector(state => state.contract.loading.updateContract);
    const selectedRole = useSelector(state => state.authentication.selectedRole);
    const actualSchoolYear = useSelector(state => state.jointPower.actualSchoolYear);

    useEffect(() => {
        if (!classificationTypes.length && !isLoadingClassificationTypes) {
            dispatch(getClassificationTypesRequest());
        }
        if (classificationTypes.length > 0) {
            setValue("ClassificationType", contract.ClassificationType);
        }
        if (!usageTypes.length && !isLoadingUsageTypes) {
            dispatch(getUsageTypesRequest());
        }
        if (!actualSchoolYear) {
            dispatch(getActualSchoolYearRequest());
        }
    }, [dispatch, classificationTypes, usageTypes, contract.ClassificationType, isLoadingClassificationTypes, isLoadingUsageTypes, setValue, actualSchoolYear]);

    const onSubmit = myData => {
        if (selectedRole !== undefined) {
            myData.selectedRole = selectedRole;
        }
        if (!isUpdatingContract) {
            dispatch(updateContractRequest(myData));
            setCurrentStep();
        }
    }

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit(onSubmit)} className="contract-form">
                <div className="mb-3 form-group">
                    <label htmlFor="Start" className="form-label">Startdatum</label>
                    <input
                        type="date"
                        {...register("Start")}
                        className="form-control"
                        defaultValue={actualSchoolYear.Start}
                    />
                    {errors.StartDate && <p className="error-message">{errors.StartDate.message}</p>}
                </div>

                <div className="mb-3 form-group">
                    <label htmlFor="End" className="form-label">Enddatum</label>
                    <input
                        type="date"
                        {...register("End")}
                        defaultValue={actualSchoolYear.End}
                        className="form-control"
                    />
                    {errors.EndDate && <p className="error-message">{errors.EndDate.message}</p>}
                </div>

                <div className="mb-3 form-group">
                    <label htmlFor="NewOrExtension" className="form-label">Neu/Verlängerung</label>
                    <select {...register("NewOrExtension", {required: "Neu/Verlängerung ist erforderlich!"})}
                            className="form-select"
                            defaultValue={contract.NewOrExtension}
                    >
                        <option value="NONE">Bitte wählen</option>
                        <option value="NEW">Neu</option>
                        <option value="EXTENSION">Verlängerung</option>
                    </select>
                    {errors.NewOrExtension && <p className="error-message">{errors.NewOrExtension.message}</p>}
                </div>
                <div className="form-navigation-buttons">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={previousStep}
                    >
                        <FaArrowLeft/> Zurück
                    </button>
                    <button type="submit" className="btn btn-primary">{submitButtonText}</button>
                </div>
            </form>
        </div>
    );
};

export default ContractForm;
